var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"upload",staticClass:"upload",attrs:{"name":"multipartFile","accept":".xls, .xlsx","action":_vm.uploadUrl,"before-upload":_vm.beforeUpload,"on-success":_vm.uploadSuccess,"show-file-list":false}},[_c('el-button',{attrs:{"size":"small","type":"primary","plain":"","round":""}},[_vm._v("批量导入")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }